<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-03-31 09:13:34
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-07-02 16:06:42
 * @Description: 信息调价
 * @FilePath: /icps_pcweb/src/views/platform/ICPS/internetSales/dialog/informationSetPriceDialog.vue
-->
<template>
        <el-dialog v-dialogDrag :visible.sync="infoDialog" width="1300px" :append-to-body="true" :close-on-click-modal="false" :before-close="close">
            <span slot="title" class="dialog-title">信息调价</span>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="dialogData" tooltip-effect="dark">
                <el-table-column align="center" label="强度等级2">
                <el-table-column align="center" label="泵送">
                    <!-- <el-table-column align="center" label="生效日期" prop="startTime" width="200">
                    <template slot-scope="scope">
                        <el-date-picker v-model="scope.row.startTime" popper-class="popperClass" style="width: 200px;" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"> </el-date-picker>
                    </template>
                    </el-table-column> -->
                    <el-table-column align="center" label="砼单价" prop="startTime" min-width="150">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.concretePriceMethod" placeholder="请选择">
                        <el-option :key="1" label="按C30信息价" :value="1"> </el-option>
                        <el-option :key="2" label="按标号信息价" :value="2"> </el-option>
                        <el-option :key="3" label="按砌筑砂浆M5价" :value="3"> </el-option>
                        </el-select>
                    </template>
                    </el-table-column>
                    <el-table-column align="center" label="城市" prop="startTime" width="200">
                    <template slot-scope="scope">
                        <!-- <el-cascader ref="address" v-model="scope.row.areaCode0" style="width: 150px" :options="treeData" filterable @change="administrativeDistrictsFun()"></el-cascader> -->
                        <el-select ref="cityCode" v-model="scope.row.cityCode" placeholder="请选择" @change="$nextTick(() => { scope.row.cityName = $refs.cityCode.selectedLabel; selectCity(scope.row.cityCode);})">
                            <el-option :key="1" label="成都" value="chendu"> </el-option>
                            <el-option :key="2" label="重庆" value="chongqing"> </el-option>
                            <el-option :key="3" label="绵竹" value="mianzhu"> </el-option>
                            <el-option :key="4" label="遂宁" value="suining"> </el-option>
                            <el-option :key="5" label="资阳" value="ziyang"> </el-option>
                            <el-option :key="6" label="德阳" value="deyang"> </el-option>
                            <el-option :key="7" label="眉山" value="meishan"> </el-option>
                            <el-option :key="8" label="宜宾" value="yibin"> </el-option>
                            <el-option :key="9" label="内江" value="neijiang"> </el-option>
                            <el-option :key="10" label="西昌" value="xichang"> </el-option>
                            <el-option :key="11" label="绵阳" value="mianyang"> </el-option>
                            <el-option :key="12" label="广安" value="guangan"> </el-option>
                            <el-option :key="13" label="达州" value="dazhou"> </el-option>
                            <el-option :key="14" label="南充" value="nanchong"> </el-option>
                            <el-option :key="15" label="乐山" value="leshan"> </el-option>
                        </el-select>
                    </template>
                    </el-table-column>
                    <el-table-column align="center" label="行政区" prop="startTime" width="200">
                    <template slot-scope="scope">
                        <el-select ref="areaId" v-model="scope.row.areaId" placeholder="请选择" @change=" $nextTick(() => { scope.row.areaName = $refs.areaId.selectedLabel; })">
                            <el-option v-for="item in areaList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                        </el-select>
                    </template>
                    </el-table-column>
                    <el-table-column align="center" label="对应关系" prop="startTime" width="220">
                    <template slot-scope="scope">
                        当月对应
                        <el-select v-model="scope.row.correspondence" size="mini" placeholder="请选择" style="width: 100px">
                        <el-option :key="0" label="当期" :value="0"> </el-option>
                        <el-option :key="1" label="上一月" :value="1"> </el-option>
                        <el-option :key="2" label="上二月" :value="2"> </el-option>
                        <el-option :key="3" label="上三月" :value="3"> </el-option>
                        <el-option :key="4" label="上四月" :value="4"> </el-option>
                        <el-option :key="5" label="上五月" :value="5"> </el-option>
                        <el-option :key="6" label="上六月" :value="6"> </el-option>
                        <el-option :key="7" label="上七月" :value="7"> </el-option>
                        <el-option :key="8" label="上八月" :value="8"> </el-option>
                        <el-option :key="9" label="上九月" :value="9"> </el-option>
                        <el-option :key="10" label="上十月" :value="10"> </el-option>
                        <el-option :key="11" label="上十一月" :value="11"> </el-option>
                        <el-option :key="12" label="上十二月" :value="12"> </el-option>
                        <el-option :key="20" label="年平均" :value="20"> </el-option>
                        </el-select>
                        信息价
                    </template>
                    </el-table-column>
                    <el-table-column align="center" label="价格方式" prop="startTime" width="120">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.pumpingPriceMode" placeholder="请选择">
                        <el-option :key="1" label="按比例" :value="1"> </el-option>
                        <el-option :key="2" label="按固定金额" :value="2"> </el-option>
                        </el-select>
                    </template>
                    </el-table-column>
                    <el-table-column align="center" label="浮动" prop="startTime" width="120">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.pumpingFloat" placeholder="请选择">
                        <el-option :key="1" label="上浮" :value="1"> </el-option>
                        <el-option :key="2" label="下浮" :value="2"> </el-option>
                        </el-select>
                    </template>
                    </el-table-column>
                    <el-table-column align="center" label="调整情况" width="150">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.pumpingAdjustBase" type="Number" style="width: 100%" @mousewheel.native.prevent>
                        <template slot="append">{{scope.row.pumpingPriceMode == 1 ? '%':'元'}}</template>
                        </el-input>
                    </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column align="center" label="非泵送">
                    <el-table-column align="center" label="价格方式" prop="startTime" width="120">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.nonPumpingPriceMode" placeholder="请选择">
                        <el-option :key="1" label="按比例" :value="1"> </el-option>
                        <el-option :key="2" label="按固定金额" :value="2"> </el-option>
                        </el-select>
                    </template>
                    </el-table-column>
                    <el-table-column align="center" label="浮动" prop="startTime" width="120">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.nonPumpingFloat" placeholder="请选择">
                        <el-option :key="1" label="上浮" :value="1"> </el-option>
                        <el-option :key="2" label="下浮" :value="2"> </el-option>
                        </el-select>
                    </template>
                    </el-table-column>
                    <el-table-column align="center" label="调整情况" width="150">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.nonPumpingAdjustBase" type="Number" style="width: 100%" @mousewheel.native.prevent>
                        <template slot="append">{{scope.row.nonPumpingPriceMode == 1 ? '%':'元'}}</template>
                        </el-input>
                    </template>
                    </el-table-column>
                </el-table-column>
                </el-table-column>
            </el-table>
            <div style="display:flex; flex-direction: row;">
                <div style="margin-top: 10px;">上传附件:</div>
                <div style="padding-left: 42px">
                    <FileComponent2 fileCode="priceFile" :files="files" @deleteFile="deleteFile" @uplodeSuccess="uplodeSuccess" />
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="close()">取 消</el-button>
                <el-button class="bottom_all" style="margin-left: 24px" @click="infoSubmitFun">确 定</el-button>
            </span>
        </el-dialog>
</template>

<script>
import { savePrising,queryPatternList } from "@/api/internetSales/engineeringControl.js";
import FileComponent2 from "@/views/platform/ICPS/internetSales/components/fileComponent";

export default {
    components: {
        FileComponent2,
    },
    props: {
        infoDialog: {
            type: Boolean,
            default: false,
        },
        infoId: {
            type: String,
            default: '',
        },
        engineeringId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            dialogData: [
                {   
                    cityCode:"",
                    cityName:"",
                    areaid: "", //区县编号
                    areaName: [],
                    concretePriceMethod: "", //砼单价，1按c30信息价，2按标号信息价
                    correspondence: "", //对应关系:0当期；1上一月；2上二月；3上三月；4上四月；5上五月；6上六月；7上七月；8上八月；9上九月；10上十月；11上十一月；12上十二月；20年平均
                    enclosureUrl: "", //附件url
                    engineeringId: "", //工程id
                    nonPumpingAdjustBase: "", //(非泵送)调整情况
                    nonPumpingFloat: "", //(非泵送)浮动：1上浮；2下浮
                    nonPumpingPriceMode: "", //(非泵送)价格方式：1按比例；2按固定金额
                    pumpingAdjustBase: "", //(泵送)调整情况
                    pumpingFloat: "", //(泵送)浮动：1上浮；2下浮
                    pumpingPriceMode: "", //(泵送)价格方式：1按比例；2按固定金额
                    startTime: "", //生效时间
                },
            ],
            files: [],
            areaList:"",
        }
    },
    methods: {
        //选择城市获取区域
        selectCity(cityCode) {
            queryPatternList({ informationPriceType: 1, cityDode: cityCode }).then(res => {
                if (res.code == 1001) {
                this.areaList = res.data.areaList;
                }
      });
        },
        close(){
            this.dialogData = [
                {
                    areaCode: "", //区县编号
                    areaCode0: [],
                    concretePriceMethod: "", //砼单价，1按c30信息价，2按标号信息价
                    correspondence: "", //对应关系:0当期；1上一月；2上二月；3上三月；4上四月；5上五月；6上六月；7上七月；8上八月；9上九月；10上十月；11上十一月；12上十二月；20年平均
                    enclosureUrl: "", //附件url
                    engineeringId: "", //工程id
                    nonPumpingAdjustBase: "", //(非泵送)调整情况
                    nonPumpingFloat: "", //(非泵送)浮动：1上浮；2下浮
                    nonPumpingPriceMode: "", //(非泵送)价格方式：1按比例；2按固定金额
                    pumpingAdjustBase: "", //(泵送)调整情况
                    pumpingFloat: "", //(泵送)浮动：1上浮；2下浮
                    pumpingPriceMode: "", //(泵送)价格方式：1按比例；2按固定金额
                    startTime: "", //生效时间
                },
            ]
            this.$emit('closeInformationSetPriceDialog', false)
        },
        infoSubmitFun(){
            const params = { ...this.dialogData[0], engineeringId: this.engineeringId, readjustPricesResordId: this.infoId, enclosureUrl: JSON.stringify(this.files) };
            params.areaCode = JSON.stringify(params.areaCode0)
            savePrising(params).then(res => {
                if (res.code == 1001) {
                    this.$message({ message: "保存成功", type: "success", });
                    this.$emit('refInfoPriceDialog')
                    this.close()
                }
            });
        },
        deleteFile(index) {
            this.files.splice(index, 1);
        },
        uplodeSuccess(data) {
            const params = {
                name: data.fileName,
                fileName: data.fileName,
                fileUrl: data.fileUrl,
                path: data.fileUrl,
                fileType: 1,
                type: 1,
                createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
            };
            this.files.push(params);
        },
    },
}
</script>

<style lang="scss" scoped>
.popperClass.el-date-picker {
    width: 220px;
}
</style>